import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

interface SelectWarningProps {
	text: string;
	Icon: React.ElementType;
}

//TODO[ADRIAN]: This is not that much necessary, or its not only warning component...
export const SelectWarningComponent: FC<SelectWarningProps> = ({
	text,
	Icon,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			sx={{ color: theme.palette.warning.main }}
			gap={1}
			mt={1}
		>
			<Icon style={{ lineHeight: theme.typography.body2.lineHeight }} />
			<Typography variant="body2">{text}</Typography>
		</Stack>
	);
};
